import { Images as ABCyaImages } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class BlobFill extends Phaser.GameObjects.Container {

  constructor (scene, row, col, direction) {
    super(scene);

    this.sprite = this.scene.add.sprite(0, 0, ABCyaImages.DEFAULT_ATLAS, UIAssetKeys._purpleSheet_purpleSheet2_0).setOrigin(0.5);
    this.add(this.sprite);

    this.name = 'BlobFill';
    this.row = row;
    this.column = col;
    this.direction = direction;
    this.enabled = true;

    switch (direction) {

      case -1:
      case 0:
      case 6:
        this.angle = 0 - 2;
        break;

      case 1:
        this.angle = 90 - 2;
        break;

      case 2:
        this.angle = 180 - 2;
        break;

      case 3:
        this.angle = 270 - 2;
        break;
    }

    this.setScale(0.58);

    this.sprite.x -= 4;

  };
}